const Vue = window.Vue;
const VueRouter = require('vue-router').default;

const withdrawRouter = new VueRouter({
    routes: [
        { 
            name: 'withdraw-01',
            path: '/',
            component: require('./components/pages/withdraw/01.vue').default 
        },
        {
            name: 'withdraw-02',
            path: '/02',
            component: require('./components/pages/withdraw/02.vue').default
        },
        {
            name: 'withdraw-03',
            path: '/03',
            component: require('./components/pages/withdraw/03.vue').default
        },
        {
            name: 'withdraw-otp-test',
            path: '/test',
            component: require('./components/pages/withdraw/OTPTest.vue').default
        }
    ],
})

Vue.component('withdraw-entry', require('./components/pages/withdraw/Index.vue').default)

if ($('#withdraw-app').length) { // for deposit-app
    const app = new Vue({
        router: withdrawRouter
    }).$mount('#withdraw-app');
}